import React from 'react'
import { Route, Routes } from "react-router-dom"
import ShipmentFulfillmentDocumentCreateScreen from "screens/App/CRM/ShipmentFulfillmentDocument/ShipmentFulfillmentDocumentCreateScreen"
import ShipmentFulfillmentDocumentDetailScreen from "screens/App/CRM/ShipmentFulfillmentDocument/ShipmentFulfillmentDocumentDetailScreen"
import ShipmentFulfillmentDocumentEditScreen from "screens/App/CRM/ShipmentFulfillmentDocument/ShipmentFulfillmentDocumentEditScreen"
import ShipmentFulfillmentDocumentListScreen from "screens/App/CRM/ShipmentFulfillmentDocument/ShipmentFulfillmentDocumentListScreen"

const ShipmentFulfillmentDocumentRouter = () => {
  return (
    <Routes>

      <Route path="list" element={<ShipmentFulfillmentDocumentListScreen />} />

      <Route path="create" element={<ShipmentFulfillmentDocumentCreateScreen />} />

      <Route path=":id/edit" element={<ShipmentFulfillmentDocumentEditScreen />} />

      <Route path=":id/detail" element={<ShipmentFulfillmentDocumentDetailScreen />} />

    </Routes>
  )
}

export default ShipmentFulfillmentDocumentRouter;